// mugs.js — safe legacy guard.
// Main mug behavior lives in snippets/mug-block.liquid because it needs Liquid product data.
(function () {
  if (window.__MUGS_LEGACY_INIT__) return;
  window.__MUGS_LEGACY_INIT__ = true;

  const mugWrap = document.querySelector('#mug-customizer');
  if (!mugWrap) return;

  // If the current snippet already initialized the mug customizer, do nothing.
  if (window.__MUG_INIT__) return;

  const nameInp = mugWrap.querySelector('#mug-name-input');
  const btn = mugWrap.querySelector('#mug-atc-btn');
  const variantId = document.querySelector('[name="id"]')?.value;

  if (!btn || !variantId) return;

  function refreshUI() {
    const ready = !nameInp || !!nameInp.value.trim();
    btn.disabled = !ready;
    btn.classList.toggle('disabled', !ready);
  }

  if (nameInp) nameInp.addEventListener('input', refreshUI);
  refreshUI();
})();
